import { render } from "./MyPaymentRecord.vue?vue&type=template&id=dd485056&scoped=true"
import script from "./MyPaymentRecord.vue?vue&type=script&lang=js"
export * from "./MyPaymentRecord.vue?vue&type=script&lang=js"

import "./MyPaymentRecord.vue?vue&type=style&index=0&id=dd485056&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd485056"]])

export default __exports__